import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
import SharedItem from './SharedItem';
var Newsletter = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment newsletter on Newsletter {\n    origin\n    invalidEmail\n    invalidName\n    default {\n      ...sharedItems\n    }\n    success {\n      ...sharedItems\n    }\n    error {\n      ...sharedItems\n    }\n  }\n  ", "\n"])), SharedItem);
export default Newsletter;